module.exports = __webpack_public_path__ + "img/first_course_session.475b444a.svg";